(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["works-availability-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeWorksAvailability() {
      const dialog = document.getElementById('works-availability');
      if (!dialog || dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      let opener = null;
      let submitting = false;
      const openDialog = (trigger) => {
        submitting = false;
        opener = trigger || document.activeElement;
        if (!dialog.open) dialog.showModal();
        const target = dialog.querySelector('[data-works-availability-result="success"]') || dialog.querySelector('input[type="email"]');
        target?.focus({ preventScroll: true });
      };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-works-availability-trigger]');
        if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openDialog(trigger);
      });
      dialog.querySelector('[data-works-availability-close]')?.addEventListener('click', () => dialog.close());
      dialog.querySelector('form')?.addEventListener('submit', () => {
        submitting = true;
        dialog.close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!submitting && opener instanceof HTMLElement && opener.isConnected) opener.focus({ preventScroll: true });
        if (['#works-availability', '#works-availability-form'].includes(window.location.hash)) {
          history.replaceState(history.state, '', window.location.pathname + window.location.search);
        }
      });
      if (dialog.querySelector('[data-works-availability-result]') || ['#works-availability', '#works-availability-form'].includes(window.location.hash)) openDialog();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWorksAvailability, { once: true });
    else initializeWorksAvailability();
    document.addEventListener('shopify:section:load', initializeWorksAvailability);
  })();
  } catch(e) { console.error(e); }
})();

})();
